import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../Layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home", // name 一定要跟组件名一样，默认的组件名是大驼峰命名
    component: Layout,
    meta: {
      title: "投资理财",
      keepAlive: true, // 需要缓存
    },
    redirect: "/FinancialInvestment",
    children: [
      {
        path: "/FinancialInvestment",
        name: "FinancialInvestment", // name 一定要跟组件名一样，默认的组件名是大驼峰命名
        component: () => import("@/views/FinancialInvestment"),
        meta: {
          title: "投资理财",
          keepAlive: true, // 需要缓存
        },
      },
      {
        path: "/Live",
        name: "Live", // name 一定要跟组件名一样，默认的组件名是大驼峰命名
        component: () => import("@/views/Live"),
        meta: {
          title: "直播路演",
          keepAlive: true, // 需要缓存
        },
      },
      {
        path: "/News",
        name: "News", // name 一定要跟组件名一样，默认的组件名是大驼峰命名
        component: () => import("@/views/News"),
        meta: {
          title: "热点资讯",
          keepAlive: true, // 需要缓存
        },
      },
      {
        path: "/NewsLetter",
        name: "NewsLetter", // name 一定要跟组件名一样，默认的组件名是大驼峰命名
        component: () => import("@/views/NewsLetter"),
        meta: {
          title: "太傅快讯",
          keepAlive: true, // 需要缓存
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
